var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBullet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39.04969,
    height: 17.005253,
    viewBox: "0 0 10.331897 4.4993066",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-15.235505,-43.523375)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.613776,
      strokeLinecap: "round",
      strokeMiterlimit: 20,
      strokeDasharray: "none",
      stopColor: "#000000"
    },
    d: "m 15.849282,44.139231 c 0.201404,-0.473027 0.530844,-0.347515 0.818368,0 h 4.09184 c -0.428258,1.192373 -0.409184,2.045922 0,3.273474 h -4.09184 c -0.266113,0.201009 -0.562161,0.576946 -0.818368,0 -0.409185,-0.818369 -0.409185,-2.455104 0,-3.273474 z",
    id: "path6258-57"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.613776,
      strokeLinecap: "round",
      strokeMiterlimit: 20,
      strokeDasharray: "none",
      stopColor: "#000000"
    },
    d: "m 16.66765,44.139231 c -0.409184,0.81837 -0.437788,2.460804 0,3.273474",
    id: "path6258-5-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6473-3-6",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.613776,
      strokeLinecap: "round",
      strokeMiterlimit: 20,
      strokeDasharray: "none",
      stopColor: "#000000"
    },
    d: "m 20.75949,47.412573 c 1.227552,0 4.501024,-0.409183 4.501024,-1.636735 0,-1.227552 -3.385342,-1.673198 -4.501024,-1.636738"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullet);
export default __webpack_public_path__ + "static/media/bullet.2b6cce563fb724a0e3786ddc2fa37316.svg";
export { ForwardRef as ReactComponent };